var map = {
	"./Project/Cric.png": 4861,
	"./Project/netmeds.png": 7288,
	"./Project/rodan.png": 4157,
	"./Project/youtube.png": 7117,
	"./Project/zappos.png": 2377,
	"./about.jpg": 2543,
	"./aboutCropped.jpg": 5018,
	"./aboutFinal.jpg": 980,
	"./chakraui.svg": 9989,
	"./css.svg": 6743,
	"./express.svg": 1022,
	"./git.svg": 8352,
	"./html.svg": 7530,
	"./js.svg": 7751,
	"./mongodb.svg": 5028,
	"./nodejs.svg": 1194,
	"./ntmd.png": 1423,
	"./profile.png": 7619,
	"./react.png": 254,
	"./redux.svg": 4961,
	"./sideContact.jpg": 9350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4339;